import React from 'react';
import { PageLayout } from '../PageLayout';
import { TablesComponent } from '../PM/TablesComponent';
import { ContractCharacteristics } from '../PM/ContractCharacteristics';
import { DeclarationsComponent } from '../DeclarationsComponent';
import { SignatureSection } from '../SignatureSection';

// Helper component for table cells


export const Page1 = ({ data, type }) => {
    const t = data.tenant;

    // Format dates if needed
    const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('es-MX');
        } catch (e) {
            return dateString;
        }
    };

    return (
        <PageLayout data={data}>
            {/* tablas */}
            <TablesComponent data={data} type="PF" />

             {/* Caracteristicar y firma PF */}
            <ContractCharacteristics data={data} type="PF" />


            {/* Declarations */}
            <DeclarationsComponent  type="PF" data={data} />

           
            {/* Signature Section */}
          {/* <SignatureSection data={data} type="PF" /> */}

        </PageLayout>
    );
};
